/* Allin1 Print & Sign · theme.js
   Global behaviour: hours, nav, hero, motion, cart drawer, product chooser + template picker,
   home catalog grid + template shelf, send-a-file ticket. Product page logic lives in product.js. */
(function () {
  'use strict';
  const A1 = window.A1 = window.A1 || {};
  const $ = id => document.getElementById(id);
  const esc = s => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  const TPL = 'https://d1p81tn8mwpox2.cloudfront.net/?k=s3%3A%2F%2Fapp-print-cdn%2Fpreview_content_';
  const CATALOG = A1.catalog || [];
  const FMT = typeof A1.money === 'string' ? A1.money : '${{amount}}';
  const money = cents => {
    const n = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const f = FMT;
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n).replace(/<[^>]+>/g, '');
  };
  A1.$ = $; A1.esc = esc; A1.money = money;

  /* ---------- catalog helpers ---------- */
  const byHandle = h => CATALOG.find(p => p.handle === h);
  CATALOG.forEach(p => {
    const T = typeof TEMPLATES !== 'undefined' ? TEMPLATES : (window.TEMPLATES || {});
    const list = T[p.handle] || [];
    p.designs = list.map(([id, img, name]) => ({ id, name, url: TPL + img + '.png&size=700' }));
    p.qi = p.options.findIndex(o => o.name === 'Quantity');
  });
  function variantFor(p, sel) {
    return p.variants.find(v => v.opts.every((o, i) => !sel[i] || o === sel[i])) || p.variants[0];
  }
  function renderOpts(host, p, prefix) {
    host.innerHTML = p.options.filter(o => o.name !== 'Quantity' && !(o.name === 'Title' && o.values.length === 1)).map(o => {
      const i = p.options.indexOf(o);
      return `<label class="f"><span>${esc(o.name)}</span><select id="${prefix}_${i}" data-i="${i}">${o.values.map(v => `<option>${esc(v)}</option>`).join('')}</select></label>`;
    }).join('');
  }
  function readOpts(host, p) {
    syncOpts(host, p);
    const sel = new Array(p.options.length).fill(null);
    host.querySelectorAll('select[data-i]').forEach(s => sel[+s.dataset.i] = s.value);
    return sel;
  }
  /* Not every combination of option values exists as a variant (booklets: 12 x 12 is spiral only). Mirror the
     shop's own behaviour: grey out values that have no variant with the other current choices, and if the
     current choices don't exist together, keep them left to right as far as a variant allows. */
  const fits = (v, sel, skip) => sel.every((x, j) => j === skip || x == null || v.opts[j] === x);
  function syncOpts(host, p) {
    const selects = [...host.querySelectorAll('select[data-i]')]; if (!selects.length) return;
    const read = () => { const s = new Array(p.options.length).fill(null); selects.forEach(el => s[+el.dataset.i] = el.value); return s; };
    let cur = read();
    if (!p.variants.some(v => fits(v, cur, -1))) {
      const keep = new Array(p.options.length).fill(null);
      cur.forEach((x, i) => { if (x == null) return; keep[i] = x; if (!p.variants.some(v => fits(v, keep, -1))) keep[i] = null; });
      const v = p.variants.find(v => fits(v, keep, -1)) || p.variants[0];
      selects.forEach(el => el.value = v.opts[+el.dataset.i]);
      cur = read();
    }
    selects.forEach(el => {
      const i = +el.dataset.i;
      [...el.options].forEach(o => { const ok = p.variants.some(v => v.opts[i] === o.value && fits(v, cur, i)); o.disabled = !ok; });
    });
  }
  /* quantity UI: pack products (business cards, letterhead, envelopes) sell in fixed tiers → a dropdown that picks the variant;
     everything else a free number field, minimum enforced on submit, never while typing. */
  function qtyUI(wrap, p) {
    const input = wrap.querySelector('input[name="quantity"]');
    let tier = wrap.querySelector('select.tier');
    if (p.qi >= 0) {
      if (!tier) { tier = document.createElement('select'); tier.className = 'tier'; input.after(tier); }
      tier.innerHTML = p.options[p.qi].values.map(v => `<option value="${esc(v)}">${(+v).toLocaleString()}</option>`).join('');
      tier.hidden = false; input.hidden = true; input.value = 1;
    } else {
      if (tier) tier.hidden = true;
      input.hidden = false; input.min = 1; input.placeholder = p.min > 1 ? String(p.min) : '';
    }
    return { input, tier };
  }
  function priceFor(p, sel, qty) {
    if (p.qi >= 0) {
      const v = variantFor(p, sel);
      const n = +v.opts[p.qi] || 1;
      return { v, qty: n, total: v.price, unit: `${money(v.price / n)} each`, pack: true };
    }
    const v = variantFor(p, sel);
    qty = Math.max(qty || 1, p.min || 1);
    return { v, qty, total: v.price * qty, unit: `${money(v.price)} each`, pack: false };
  }
  function optsLabel(p, sel) { return sel.filter((v, i) => v && i !== p.qi && v !== 'Default Title').join(' · '); }
  Object.assign(A1, { byHandle, variantFor, renderOpts, readOpts, qtyUI, priceFor, optsLabel, CATALOG });

  /* ---------- overlays / toast ---------- */
  function open(id) { const el = $(id); if (!el) return; el.hidden = false; document.body.style.overflow = 'hidden'; }
  function close(id) { const el = $(id); if (!el) return; el.hidden = true; if (!document.querySelector('.ov:not([hidden])')) document.body.style.overflow = ''; }
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-close]'); if (b) close(b.dataset.close);
    if (e.target.classList.contains('ov')) close(e.target.id);
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') document.querySelectorAll('.ov:not([hidden])').forEach(o => close(o.id)); });
  let toastT;
  function toast(m) { const t = $('toast'); if (!t) return; t.textContent = m; t.classList.add('show'); clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('show'), 2200); }
  Object.assign(A1, { open, close, toast });

  /* ---------- hours + clock (America/Denver) ---------- */
  function denver() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Denver' })); }
  function tickClock() {
    const d = denver(), day = d.getDay(), h = d.getHours() + d.getMinutes() / 60, cutoff = +A1.cutoff || 14;
    const isOpen = day >= 1 && day <= 5 && h >= 8 && h < 17;
    const st = $('status');
    if (st) {
      st.classList.toggle('open', isOpen); st.classList.toggle('closed', !isOpen);
      let msg;
      if (isOpen) msg = h < cutoff ? `Open · same-day rush until ${cutoff > 12 ? cutoff - 12 : cutoff}:00` : 'Open · closes at 5:00';
      else { const next = (day === 5 && h >= 17) || day === 6 ? 'Monday' : day === 0 ? 'tomorrow' : h < 8 ? 'today' : 'tomorrow'; msg = `Closed · opens ${next} at 8:00`; }
      st.querySelector('span').textContent = msg;
    }
    if ($('clockTime')) { $('clockTime').textContent = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }); $('clockMsg').textContent = (isOpen ? 'Open now' : 'Closed') + ' · Richfield time'; }
  }
  tickClock(); setInterval(tickClock, 15000);
  if ($('burger')) {
    $('burger').addEventListener('click', () => { $('mnav').hidden = !$('mnav').hidden; });
    $('mnav').addEventListener('click', e => { if (e.target.tagName === 'A') $('mnav').hidden = true; });
  }

  /* ---------- cart drawer (Shopify AJAX cart) ---------- */
  const CART = {
    data: null,
    async fetch() { this.data = await fetch('/cart.js', { headers: { Accept: 'application/json', 'X-A1': '1' } }).then(r => r.json()); this.render(); return this.data; },
    async add(formData) {
      const r = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json', 'X-A1': '1' } });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag');
      await this.fetch(); return j;
    },
    async change(key, quantity) {
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-A1': '1' }, body: JSON.stringify({ id: key, quantity }) });
      await this.fetch();
    },
    render() {
      const c = this.data; if (!c) return;
      const count = $('cartcount'); if (count) { count.textContent = c.item_count; count.hidden = !c.item_count; }
      const host = $('cartItems'); if (!host) return;
      host.innerHTML = c.items.length ? c.items.map(i => this.row(i, false)).join('') : '<div class="empty">Nothing on the ticket yet</div>';
      if ($('sumSub')) $('sumSub').textContent = money(c.total_price);
      const co = $('checkoutBtn'); if (co) { co.style.opacity = c.item_count ? '' : '.35'; co.style.pointerEvents = c.item_count ? '' : 'none'; }
      document.dispatchEvent(new CustomEvent('a1:cart', { detail: c }));
    },
    row(i, page) {
      const props = Object.entries(i.properties || {}).filter(([k, v]) => v && !k.startsWith('_')).map(([k, v]) => {
        const val = typeof v === 'string' && /^https?:\/\//.test(v) ? `<a href="${esc(v)}" target="_blank" rel="noopener">${esc(v.split('/').pop().split('?')[0])}</a>` : esc(v);
        return `<span>${esc(k)}: ${val}</span>`;
      }).join('');
      const variant = i.variant_title && i.variant_title !== 'Default Title' ? `<span>${esc(i.variant_title)}</span>` : '';
      const img = i.image ? `<img src="${esc(i.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2'))}" alt="">` : '<div class="ph">ITEM</div>';
      return `<div class="ci cart-item" data-line-item-key="${esc(i.key)}" data-key="${esc(i.key)}">
        ${img}
        <div><b><a href="${esc(i.url)}" style="color:inherit">${esc(i.product_title)}</a></b>${variant}<div class="props">${props}</div>
          <div class="qty"><button type="button" data-q="-1" aria-label="Less">−</button><input type="number" value="${i.quantity}" min="0" data-key="${esc(i.key)}" aria-label="Quantity"><button type="button" data-q="1" aria-label="More">+</button></div>
          <button class="rm" type="button" data-rm="${esc(i.key)}">Remove</button></div>
        <div class="pr">${money(i.final_line_price)}</div></div>`;
    }
  };
  A1.cart = CART;
  /* any script that talks to the cart (the options app, Print.App) → keep the drawer in sync */
  (function watchCart() {
    const orig = window.fetch;
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const p = orig.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url) && !(init && init.headers && init.headers['X-A1'])) {
        p.then(r => { if (r.ok) { CART.fetch(); if (/\/cart\/add/.test(url)) document.dispatchEvent(new CustomEvent('a1:cart:added')); } }).catch(() => {});
      }
      return p;
    };
    const xo = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) { this.addEventListener('load', () => { if (this.status < 300 && /\/cart\/(add|change|update|clear)/.test(String(url))) { CART.fetch(); if (/\/cart\/add/.test(String(url))) document.dispatchEvent(new CustomEvent('a1:cart:added')); } }); return xo.apply(this, arguments); };
  })();
  document.addEventListener('click', async e => {
    const rm = e.target.closest('[data-rm]'); if (rm) { rm.closest('.ci').classList.add('busy'); return CART.change(rm.dataset.rm, 0); }
    const q = e.target.closest('[data-q]'); if (q) { const inp = q.parentElement.querySelector('input'); const n = Math.max(0, (+inp.value || 0) + +q.dataset.q); inp.value = n; q.closest('.ci').classList.add('busy'); return CART.change(inp.dataset.key, n); }
    if (e.target.closest('#cartbtn')) { e.preventDefault(); CART.fetch(); open('cartOv'); }
  });
  document.addEventListener('change', e => { const inp = e.target.closest('.ci .qty input'); if (inp) { inp.closest('.ci').classList.add('busy'); CART.change(inp.dataset.key, Math.max(0, +inp.value || 0)); } });
  if (document.body.classList.contains('t-cart')) CART.fetch();

  /* ---------- product chooser + template picker (→ product page) ---------- */
  function openChooser() {
    const grid = $('chooseGrid'); if (!grid) return;
    grid.innerHTML = CATALOG.filter(p => p.designs.length).map(p => `<button type="button" data-launch="${p.handle}"><span class="tpl-ph photo"><img loading="lazy" src="${esc(p.img)}" alt=""></span><span>${esc(p.name)}<small>${p.designs.length} template${p.designs.length > 1 ? 's' : ''}</small></span></button>`).join('');
    open('chooseOv');
  }
  function openPicker(p, onPick) {
    $('tplTitle').textContent = p.name;
    $('tplGrid').innerHTML = p.designs.map(d => `<button type="button" data-pick="${d.id}"><span class="tpl-ph"><img loading="lazy" src="${d.url}" alt="${esc(d.name)}"></span><span>${esc(d.name)}</span></button>`).join('');
    $('tplGrid').onclick = e => { const b = e.target.closest('[data-pick]'); if (!b) return; close('tplOv'); onPick(b.dataset.pick); };
    close('chooseOv'); open('tplOv');
  }
  function launch(p, designId) {
    if (!p) return;
    if (!p.designs.length) { location.href = p.url; return; }
    if (A1.launchInline && A1.launchInline(p, designId)) return; // product page: open editor in place
    if (!designId && p.designs.length > 1) return openPicker(p, id => launch(p, id));
    designId = designId || p.designs[0].id;
    location.href = `${p.url}?pa_design=${encodeURIComponent(designId)}`;
  }
  Object.assign(A1, { openChooser, openPicker, launch });
  document.addEventListener('click', e => {
    if (e.target.closest('[data-choose]')) return openChooser();
    const l = e.target.closest('[data-launch]'); if (l) return launch(byHandle(l.dataset.launch));
  });

  /* ---------- home: catalog grid + template shelf ---------- */
  if ($('grid')) {
    $('grid').innerHTML = CATALOG.map(p => `
      <a class="item" href="${esc(p.url)}" data-cat="${esc(p.cats)}" data-tpl="${p.designs.length ? 1 : 0}">
        <div class="ph">${p.img ? `<img loading="lazy" src="${esc(p.img)}" alt="${esc(p.name)}">` : ''}</div>
        <h3>${esc(p.name)}</h3>
        <div class="spec"><span>${esc(p.options[0] && p.options[0].name !== 'Title' ? p.options[0].name : 'Standard')}</span><b>from ${money(p.from)}${p.qi >= 0 ? ' / ' + (+p.options[p.qi].values[0]).toLocaleString() : ' ea'}</b></div>
        <div class="row">${p.designs.length ? '<span class="chip">Design online <span>›</span></span>' : '<span class="chip file">Send a file</span>'}<span class="swatch" aria-hidden="true"><i class="c"></i><i class="m"></i><i class="y"></i><i class="k"></i></span></div>
      </a>`).join('');
    $('tabs').addEventListener('click', e => {
      const b = e.target.closest('button'); if (!b) return;
      [...$('tabs').children].forEach(x => { x.classList.toggle('on', x === b); x.setAttribute('aria-selected', x === b); });
      const f = b.dataset.f;
      document.querySelectorAll('#grid .item').forEach(i => i.hidden = !(f === 'all' || i.dataset.cat.split(' ').includes(f) || (f === 'tpl' && i.dataset.tpl === '1')));
    });
  }
  if ($('shelf')) {
    $('shelf').innerHTML = CATALOG.filter(p => p.designs.length).map(p => `<button type="button" data-launch="${p.handle}"><img loading="lazy" src="${p.designs[0].url}" alt="${esc(p.name)} template"><span>${esc(p.name)}<small>${p.designs.length > 1 ? p.designs.length + ' templates' : '1 template'}</small></span></button>`).join('');
  }

  /* ---------- send-a-file: pick product + quantity, see the list price, continue to the product page ---------- */
  if ($('ticketForm')) {
    const form = $('ticketForm'), sel = $('tProduct');
    sel.innerHTML = CATALOG.map(p => `<option value="${p.handle}">${esc(p.name)}</option>`).join('');
    const want = new URLSearchParams(location.search).get('product');
    sel.value = byHandle(want) ? want : (byHandle('business-cards-1') ? 'business-cards-1' : CATALOG[0]?.handle);
    let cur = null;
    function product() {
      cur = byHandle(sel.value); if (!cur) return;
      renderOpts($('tOpts'), cur, 't');
      const { input } = qtyUI($('tQty').parentElement, cur);
      if (!input.hidden) input.value = cur.min > 1 ? cur.min : (cur.cats.includes('large') ? 1 : 100);
      price();
    }
    function price() {
      if (!cur) return;
      const sel2 = readOpts($('tOpts'), cur), tier = form.querySelector('select.tier');
      if (cur.qi >= 0 && tier && !tier.hidden) sel2[cur.qi] = tier.value;
      const qty = +$('tQty').value || 1, r = priceFor(cur, sel2, qty);
      const rush = form.querySelector('input[name="turn"]:checked').value;
      const lines = [[`${r.qty.toLocaleString()} × ${cur.name}${optsLabel(cur, sel2) ? ' · ' + optsLabel(cur, sel2) : ''}`, money(r.total)]];
      lines.push(['Paper, sides, finishing', 'next step']);
      lines.push([rush.replace(/ \(.*\)/, ''), rush.startsWith('Standard') ? 'included' : 'on proof']);
      lines.push(['Digital proof', 'free']);
      $('tLines').innerHTML = lines.map(([k, v]) => `<div><dt>${esc(k)}</dt><dd>${v}</dd></div>`).join('');
      $('tTotal').textContent = money(r.total);
      $('tNote').textContent = (cur.min > 1 ? `Minimum ${cur.min}. ` : '') + 'Base list price. Paper and finishing choices on the next step may add to it.';
      return { r, rush };
    }
    sel.addEventListener('change', product);
    form.addEventListener('input', e => { if (e.target !== sel) price(); });
    form.addEventListener('change', e => { if (e.target !== sel) price(); });
    form.addEventListener('submit', e => {
      e.preventDefault(); const x = price(); if (!x) return;
      if (!x.r.pack && (+$('tQty').value || 0) < cur.min) { $('tQty').value = cur.min; price(); }
      const u = new URL(cur.url, location.origin);
      u.searchParams.set('variant', x.r.v.id); u.searchParams.set('quantity', x.r.pack ? 1 : (+$('tQty').value || cur.min || 1)); u.searchParams.set('turn', x.rush); u.searchParams.set('mode', 'file');
      location.href = u.href;
    });
    $('tDesign').addEventListener('click', () => launch(cur));
    product();
  }

  /* ---------- motion ---------- */
  (function motion() {
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { threshold: .12 });
    document.querySelectorAll('.reveal, .grid, .stagger').forEach(el => io.observe(el));
    document.querySelectorAll('.portals, .shop, .tiles').forEach(el => { el.classList.add('stagger'); io.observe(el); [...el.children].forEach((ch, i) => { ch.classList.remove('reveal'); ch.style.transitionDelay = i * 130 + 'ms'; }); });
    document.querySelectorAll('#grid .item').forEach((it, i) => it.style.transitionDelay = (i % 3) * 80 + Math.floor(i / 3) * 40 + 'ms');
    document.querySelectorAll('.steps .step').forEach((it, i) => it.style.transitionDelay = i * 120 + 'ms');
  })();

  /* ---------- hero: video, edge-color sync, scroll-away ---------- */
  (function hero() {
    const h = document.querySelector('.hero'); if (!h) return;
    const stage = $('heroStage'), v = $('heroVideo'), m = $('heroMedia'), page = $('MainContent');
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const ready = () => h.classList.add('ready');
    const logo = () => { $('heroFallback').src = h.dataset.poster; h.style.setProperty('--bg', '#000'); };
    addEventListener('scroll', () => { const y = Math.min(scrollY / innerHeight, 1); stage.style.opacity = 1 - y * .9; stage.style.transform = `scale(${1 - y * .06})`; h.classList.toggle('scrolled', scrollY > 40); }, { passive: true });
    $('heroHint').addEventListener('click', () => page.scrollIntoView({ behavior: 'smooth' }));
    if (reduce || !v.canPlayType || !v.canPlayType('video/mp4')) { logo(); return ready(); }
    v.muted = true; v.defaultMuted = true; v.setAttribute('muted', ''); v.playsInline = true;
    v.src = h.dataset.video; v.load();
    const cv = document.createElement('canvas'); cv.width = 16; cv.height = 9; const cx = cv.getContext('2d', { willReadFrequently: true });
    let raf;
    const sync = () => {
      try { cx.drawImage(v, 0, 0, 16, 9); const d = cx.getImageData(0, 0, 16, 9).data; let r = 0, g = 0, b = 0, n = 0;
        for (const [x, y] of [[0,0],[15,0],[0,8],[15,8],[7,0],[8,8],[0,4],[15,4]]) { const i = (y * 16 + x) * 4; r += d[i]; g += d[i+1]; b += d[i+2]; n++; }
        h.style.setProperty('--bg', `rgb(${r/n|0},${g/n|0},${b/n|0})`); } catch (e) {}
      if (!v.paused && !v.ended) raf = requestAnimationFrame(sync);
    };
    v.addEventListener('playing', () => { m.classList.add('playing'); cancelAnimationFrame(raf); sync(); });
    v.addEventListener('ended', () => { sync(); h.style.setProperty('--bg', '#000'); ready(); });
    v.addEventListener('error', () => { logo(); ready(); }, { once: true });
    v.addEventListener('timeupdate', () => { if (v.duration && v.currentTime > v.duration - 1.7) ready(); });
    setTimeout(() => { if (!m.classList.contains('playing')) { logo(); ready(); } }, 4000);
    const tryPlay = () => { const p = v.play(); if (p && p.catch) p.catch(() => {}); };
    tryPlay();
    const retry = () => { if (v.paused && !v.ended) tryPlay(); };
    ['touchstart', 'pointerdown', 'scroll'].forEach(ev => addEventListener(ev, retry, { once: true, passive: true }));
    v.addEventListener('canplay', () => { if (v.paused) tryPlay(); }, { once: true });
  })();

  document.dispatchEvent(new Event('a1:ready'));
})();
